module.exports = __webpack_public_path__ + "static/media/paylah-orange.32d2591c.svg";